'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["pickerRef"];
import { Component } from 'react';
import I18n from 'I18n';
import Loadable from 'UIComponents/decorators/Loadable';
import UIErrorMessage from 'UIComponents/error/UIErrorMessage';

// Taken from Loadable to support webpack 3 & 4 dynamic import compatibility.
// We need this because Loadable.renderResolved() is overridden by this render prop
import { jsx as _jsx } from "react/jsx-runtime";
function resolveImport(obj) {
  return obj && obj.__esModule ? obj.default : obj;
}
const makeAsyncPickerContent = loader => {
  const AsyncPickerContentLoader = Loadable({
    delay: 500,
    loader,
    render: (result, props) => {
      const AsyncPickerContent = resolveImport(result);
      const {
          pickerRef
        } = props,
        rest = _objectWithoutPropertiesLoose(props, _excluded);
      return /*#__PURE__*/_jsx(AsyncPickerContent, Object.assign({
        ref: pickerRef
      }, rest));
    },
    ErrorComponent: () => /*#__PURE__*/_jsx(UIErrorMessage, {
      illustration: "errors/general",
      illustrationProps: {
        width: 150
      },
      title: I18n.text('emojiPickerAddon.loadablePicker.errorTitle'),
      children: /*#__PURE__*/_jsx("p", {
        children: I18n.text('emojiPickerAddon.loadablePicker.errorMessage')
      })
    })
  });
  class AsyncPickerContentWithFocus extends Component {
    focus() {
      if (this.pickerRef && this.pickerRef.focus) {
        this.pickerRef.focus();
      }
    }
    render() {
      return /*#__PURE__*/_jsx(AsyncPickerContentLoader, Object.assign({}, this.props, {
        pickerRef: el => {
          this.pickerRef = el;
        }
      }));
    }
  }
  AsyncPickerContentWithFocus.preload = AsyncPickerContentLoader.preload;
  return AsyncPickerContentWithFocus;
};
export default makeAsyncPickerContent;